const en = {
  hero: {
    title: "A Wider World Awaits",
    subtitle: "4K Streaming · Unlimited Data · Global Servers · AI Optimization",
    free_register: "Free Register",
  },
  nav: {
    home: "Home",
    login: "Login",
    signup: "Sign up",
    pricing: "Pricing",
    faq: "FAQ",
    contact: "Contact Us",
    wechat: "WeChat",
    telegram: "Telegram",
    email: "Email",
    download: "Download Apps",
    android: "Android",
    smarttv: "Smart TV",
    userCenter: "User Center",
    logout: "Logout",
    logoutConfirm: "Are you sure you want to log out?",
  },
  common: {
    cancel: "Cancel",
    backToHome: "User Center",
    close: "Close",
  },
  faq: {
    title: "Frequently Asked Questions",
  },
  wechatModal: {
    title: "Customer Service WeChat",
    loadError: "Unable to load the WeChat QR code. Please try again later.",
    description: "Scan to add support, or search the WeChat ID below",
  },
  features: {
    title: "Why Choose ZionLadder",
    subtitle:
      "Experience stable high‑speed performance, global coverage, self‑developed apps, smart routing with AI optimization, and dedicated customer support — all in one service",
    moreLink: "Learn more",
    items: {
      1: {
        title: "4K Streaming · Unlimited Data",
        desc: "Enjoy smooth YouTube playback and Netflix HD/4K streaming with truly unlimited data usage.",
      },
      2: {
        title: "Registered French Company",
        desc: "Based in Paris, compliant with EU data protection laws for peace of mind.",
      },
      3: {
        title: "Self‑Developed Apps",
        desc: "Our self-developed apps support major platforms and prevent route or configuration data from being exposed.",
      },
      4: {
        title: "Smart Routing · AI Optimization",
        desc: "Smart traffic routing keeps domestic access fast while seamlessly connecting to the global internet. Hong Kong routes are also optimized for smooth AI application access.",
      },
      5: {
        title: "Full Technical Support",
        desc: "We provide ongoing support via WeChat, email and more, whenever you need help.",
      },
      6: {
        title: "Global High‑Speed Servers",
        desc: "Access nodes across Hong Kong, the United States, Southeast Asia, Europe, Australia, Africa, and South America with full global coverage.",
      },
    },
  },
  pricing: {
    sectionTitle: "Pricing Plans",
    sectionSubtitle:
      "Choose the plan that fits you best. All plans include full features, unlimited traffic and customer supoort",
    labels: {
      perMonth: "month",
      recommended: "Recommended",
      savePercent: "Save {{rate}}%",
      defaultCta: "Get Started",
      cta: {
        open: "Get Started",
        toUserCenter: "View My Plan",
        renew: "Renew Now",
        reopen: "Restart Plan",
      },
    },
    features: {
      bandwidth: "4K/1080P streaming supported",
      multiDevice: "Use on multiple devices you own",
      noShare: "Do not share your account with others",
      streamingUnlock: "Some servers unlock streaming",
    },
    paymentModal: {
      title: "Choose payment method - {{plan}}",
      paymentTitle: "Select a payment method",
      methods: {
        alipay: "Alipay",
        alipayDesc: "Pay with Alipay on your phone or by scanning the QR code.",
        wechat: "WeChat Pay",
        wechatDesc: "Pay with WeChat using your balance or linked cards.",
        card: "Credit / Debit Card",
        cardDesc: "Supports Visa, MasterCard and UnionPay, as well as Apple Pay and Link.",
      },
      noticeActive:
        "Renewal: This renewal will extend your current plan based on your existing expiry date, without wasting any remaining time. For example, if your current expiry date is 2025-12-31, the renewal will add the corresponding duration after this date.",
      noticeExpired:
        "Activation: Your previous plan has expired. After a successful payment, your new validity period will start from the date of payment.",
      noticeNew:
        "Activation: This is your first activation. Your plan validity will begin on the payment date; future renewals will extend from the remaining valid period without any loss of time.",
      notice:
        "After a successful payment, your plan will be activated or renewed automatically within 1 minute. If anything goes wrong, please contact support via WeChat or email.",
      confirm: "Pay",
    },
    priceNote1:
      "Priced in EUR; Alipay / WeChat Pay / UnionPay will auto-convert to CNY at checkout",
    priceNote2: "Card payments are auto-converted to your local currency, no EUR account required",
    priceNote3:
      "Some payment methods may include an additional 3%–7% processing fee charged by the provider",
    plans: {
      monthly: {
        tag: "",
        title: "Monthly Plan",
        duration: "1 month",
        discount: "40% OFF",
        cta: "Start Now",
        features: {
          1: "Unlimited traffic",
          2: "Multiple devices online",
          3: "No abusive account sharing",
          4: "4K / 1080P streaming",
          5: "Customer support (WeChat / Email)",
        },
      },
      yearly: {
        tag: "Most Popular",
        title: "Yearly Plan",
        duration: "12 months",
        discount: "60% OFF",
        cta: "Best Value",
        features: {
          1: "Unlimited traffic",
          2: "Multiple devices online",
          3: "Smooth 4K streaming",
          4: "AI-friendly optimized routes",
          5: "Priority WeChat support",
        },
      },
      halfyear: {
        tag: "",
        title: "Half-Year Plan",
        duration: "6 months",
        discount: "48% OFF",
        cta: "Start Now",
        features: {
          1: "Unlimited traffic",
          2: "Multiple devices online",
          3: "4K / 1080P streaming",
          4: "Switch between global nodes",
          5: "Customer support (WeChat / Email)",
        },
      },
    },
  },
  payments: {
    title: "Buy a Plan",
    subtitle: "Choose a payment method and channel to complete payment",
    payOptions: {
      duration: "Duration",
      total: "Total",
      methodTitle: "1. Choose payment method",
      providerTitle: "2. Choose payment channel",
      processing: "Processing…",
      retry: "Retry",
    },
    methods: {
      wechat: "WeChat Pay",
      alipay: "Alipay",
      alipayhk: "Alipay HK",
      card: "UnionPay / Credit / Debit Card",
    },
    providers: {
      stripeRecommended: "Channel 1 (Recommended)",
      airwallex: "Channel 2",
      epay: "Backup channel – multi-route rotation (refresh and retry if failed)",
    },
    notes: {
      wechatNoScreenshotForStripeAirwallex:
        "Screenshots not supported: send the QR code to another device (smartwatch is OK) and scan with WeChat.",
      wechatEpayScreenshotAllowed:
        "Screenshots supported: save the QR code and scan it from WeChat Photos.",
      unionpayNoExpiryCvcHint:
        "If your UnionPay card has no expiry/CVC printed, you may enter 12/30 and 000.",
      currencyConversion:
        "Plans are priced in EUR. Alipay / WeChat Pay / UnionPay are auto-converted to CNY; card payments are converted to your local currency. No EUR account required.",
    },
    cardChannels: {
      stripeIntent: "Stripe secure payment (Recommended): enter card details",
      stripeCheckout: "Redirect to Stripe platform (Apple Pay supported)",
    },
    loading: "Loading payment options…",
    noPaymentAction: "No payment action available.",
    alipay: {
      scan: "Scan the QR code with Alipay to pay",
    },
    wechat: {
      scan: "Scan the QR code with WeChat to pay",
    },
    qr: {
      tip: "Use your phone app to scan the QR code",
      open: "Open in payment app",
    },
    card: {
      enter: "Enter your card details",
      loading: "Processing card payment…",
      pay: "Pay with card",
      tip: "Your card information is securely processed",
    },
    polling: "Waiting for payment confirmation…",
    pollingInit: "Initializing payment status check…",
    pollingStatus: "Current payment status: {{status}}",
    pollingError: "Error checking payment status. Please try again.",
    refresh: {
      title: "Checking payment status (refreshes every 10 seconds)",
      init: "Fetching payment status…",
      status: "Current payment status: {{status}}",
      errorPrefix: "Failed to check payment status",
    },
    successTitle: "Payment Successful",
    successDesc: "Thank you for your purchase! Your plan is now active.",
    continueToUserinfo: "Continue to User Center",
    errors: {
      invalidAmount: "Invalid payment amount.",
      invalidMethod: "Unsupported payment method.",
      invalidProvider: "Unsupported payment channel.",
      paymentFailed: "Payment failed. Please try again.",
      networkError: "Network error. Please check your connection.",
      timeout: "Payment timeout. Please try again.",
      unknownError: "Unknown error occurred. Please contact support.",
    },
  },
  userInfo: {
    // Header texts
    welcomeUser: "Welcome Back",
    welcomeGuest: "Welcome to your dashboard",
    followUs: "Follow us",
    // Plan & download info
    currentPlanTitle: "Current Plan",
    planActiveUntil: "Active until {{date}}",
    planInactive: "No active plan",
    // Plan expiry display texts (used by InfoCard)
    planExpire: "Current plan valid until {{date}}",
    planExpireExpired: "Current plan expired on {{date}}",
    planCta: {
      open: "Activate plan",
      reopen: "Restart plan",
      renew: "Extend your plan",
    },
    viewPlans: "Buy a Plan or Renew",
    downloadClientTitle: "Download Client",
    downloadClientDescription: "We detected you are using {{os}}",
    downloadClientLinkLabel: "Click to download",
    downloadOtherClientsLabel: "Check All the Apps",
    os: {
      windows: "a Windows device",
      macos: "a macOS device",
      android: "an Android device",
      ios: "an iOS device",
      linux: "a Linux device",
      unknown: "this device",
    },
    verifyEmail: "Verify Email",
    confirmEmail: {
      sending: "Sending...",
      submitError: "Failed to send the confirmation email. Please try again later.",
      success: "Confirmation email sent. Please check your inbox.",
    },
    devices: {
      title: "Connected Devices",
      loading: "Loading devices...",
      empty: "No connected client devices",
      fetchError: "Failed to load device information. Please try again later.",
      unknownDevice: "Unknown device",
      unknownVersion: "Unknown version",
      summaryWithLatest: "{{count}}/{{limit}} devices, latest: {{device}} · {{version}}",
      manage: "Manage",
      disconnect: "Disconnect",
      disconnecting: "Disconnecting...",
      disconnectError: "Failed to disconnect device. Please try again later.",
      modalTitle: "Manage Connected Devices",
      modalSummary: "{{count}}/{{limit}} devices are currently connected",
      lastSeen: "Last seen {{time}}",
      expiresAt: "Valid until {{time}}",
    },
    changePassword: "Change Password",
    passwordModal: {
      title: "Change Password",
      oldPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      cancel: "Cancel",
      submit: "Change Password",
      submitting: "Changing...",
      missingFields: "Please enter your current password, new password, and confirmation",
      passwordMismatch: "The new passwords do not match",
      submitError: "Failed to change password. Please try again later.",
      success: "Password changed. Please sign in again.",
    },
    appleId: "Apple ID",
    thirdPartyLinks: "Subscription Links",
    subscriptionModal: {
      title: "Subscription Link",
      description:
        "Subscription links are for your personal use only and must not be shared. If sharing is detected, your account will be permanently disabled with no reinstatement.",
      clashDescription: "[Placeholder] Clash link description goes here. Please replace as needed.",
      loading: "Fetching subscription link...",
      fetchError: "Failed to fetch subscription link. Please try again.",
      copyError: "Copy failed. Please copy it manually.",
      retry: "Retry",
      copyButton: "Copy Link",
      copied: "Copied",
      tabs: {
        subscription: "Subscription",
        clash: "Clash",
      },
      compatibleApps: {
        subscription: "For Shadowrocket, V2rayNG Android, V2rayN Windows & macOS",
        clash: "For Clash, OpenClash; open this link in a browser to download YAML config directly",
      },
      primaryLabel: "Primary Link",
      backupLabel: "Backup Link",
      hoverToReveal: "Hover here to reveal the subscription link",
      hoverHint: "Security tip: the link is hidden again when your mouse leaves this area.",
    },
    appList: {
      title: "All Apps",
      subtitle:
        "Use our self-developed apps across major platforms, or connect with popular third-party clients — all supported here.",
      downloadLink: "Download",
      setupLink: "Go to Setup",
      comingSoon: "Coming Soon",
      ios: {
        title: "Apple iOS",
        description: "Supports iPhone, iPad, and Macs with Apple M-series chips",
      },
      macos: {
        title: "Apple macOS",
        description: "Supports Intel Macs on macOS 10.15+ and Apple M-series Macs",
      },
      android: {
        title: "Android",
        description:
          "Supports Android phones, tablets, and PCs & Zhuoyitong and Chujingyi on Huawei HarmonyOS",
      },
      windows: {
        title: "Windows",
        description: "Supports PCs installed Windows 7 x64 and Windows 10/11+",
      },
      appletv: {
        title: "Apple TV",
        description: "Supports Apple TV running tvOS 17.0+",
      },
      smarttv: {
        title: "Smart TV",
        description: "Supports Android-based Smart TVs",
      },
      openwrt: {
        title: "OpenWrt Router",
        description: "Supports routers running OpenWrt firmware",
      },
      merlin: {
        title: "ASUS Merlin",
        description: "Supports ASUS routers running Merlin or modified Merlin firmware",
      },
      linux: {
        title: "Linux",
        description: "Supports common Linux desktop and server distributions",
      },
      thirdParty: {
        title: "Third-Party Apps",
        description:
          "Compatible with Shadowrocket, V2rayN, V2rayNG, Open Clash, Clash, OpenWrt, Passwall, Merlin...",
      },
    },
  },
  clients: {
    common: {
      download: "Download",
      viewDownloads: "View Downloads",
      currentVersion: "Current version",
    },
    signedDownload: {
      title: "Download Client",
      loading: "Preparing your download...",
      started:
        "Your download should start automatically. If it does not, use the button below to download manually.",
      fallbackHint:
        "This download link is valid for {{minutes}} minutes. You can also copy it and open it in your browser.",
      fetchError: "The request could not be processed. Please try again later.",
      loginRequired: "Please sign in before generating a download link.",
      forbidden: "This account cannot generate this download link.",
      rateLimited: "Download link requests are too frequent. Please try again later.",
      copyError: "Copy failed. Please copy it manually.",
      copy: "Copy Link",
      copied: "Copied",
      manualDownload: "Manual Download",
    },
    ios: {
      softwareName: "iOS Client Placeholder",
      supportedDevices: "Supported devices: iPhone / iPad",
      version: "Current version: v1.0.0",
      currentVersionLabel: "Current Version",
      getSharedAppleId: "Get Shared Apple ID",
      desc: {
        title: "Usage Instructions",
        section1Title: "Core Features",
        section1Body:
          "1. Use the Purchase button in the top-right corner to top up your account.\n2. Tap Refresh to fetch the latest route list.\n3. Tap Share to share routes with devices on your local network.\n4. Tap the chat button to contact WeChat support.\n\nRouting modes map to different routing strategies:\n1. Smart Routing: splits domestic and overseas traffic; only overseas sites use the route.\n2. Global Mode: all traffic goes through the route, which may affect domestic app experience.",
        section2Title: "Choose a Route",
        section2Body:
          "Choose a route based on your network environment and usage needs. The green tags on the right indicate the recommended carrier and route type.\nAfter selecting a route, tap the Connect button shown above to access the internet through LadderZ.",
      },
      usage: {
        title: "Usage Instructions",
        step1: "Sign in to the App Store with the shared Apple ID and switch to an overseas store",
        step2: "Download and install the ZionLadder (LadderZ) app",
        step3:
          "Pick the right routing mode and line (match your carrier). For overseas / HK-MO-TW, direct is recommended",
        step4: "Tap Connect to start using the service",
      },
    },
    sharedid: {
      title: "Shared Apple ID",
      titleLoginRequired: "Login required",
      titlePaidRequired: "Plan required",
      titleRenewRequired: "Renew required",
      titleNoAppleId: "Not available",
      titleFetchFailed: "Request failed",

      loading: "Loading shared Apple ID…",
      okHint: "Use the account below to sign in to the App Store.",
      errorNetwork: "Network or server error. Please try again.",

      actionLogin: "Sign in",
      actionBuy: "Buy plan",
      actionRenew: "Renew",

      labelAppleId: "Apple ID",
      labelPassword: "Password",
      copied: "Copied",

      tip: "Important notes:\n1. If you already have a non‑local (overseas) Apple ID, you can directly use it to download the ZionLadder app without using the shared Apple ID\n2. The shared Apple ID is for App Store sign‑in only. Do not bind a phone number during sign‑in and please follow our step‑by‑step guide strictly\n3. The shared Apple ID is for temporary use only when downloading the app. After the download is complete, make sure to sign out and do not use it for purchases or subscriptions. Any misuse will result in immediate account revocation",
      imageHint: "Please follow the image guide below and complete the steps",
      imageDesc:
        'Open the App Store:\n1. Tap the profile icon in the top right corner\n2. Scroll to the bottom and tap Sign Out\n3. Sign in with the shared Apple ID\n4. In the pop‑up menu, select "Not XXX"\n5. Enter the shared Apple ID and password\n6. In the Apple Account Security screen, choose Other Options\n7. In the "Protect Your Account" dialog, select Do Not Upgrade\nShared Apple ID sign‑in completed',
    },
    android: {
      softwareName: "Android Client Placeholder",
      supportedDevices: "Supported devices: Android Phones/Tablets/Computer",
      version: "Current version: v1.0.0",
      currentVersionLabel: "Current Version",
      downloadApp: "Download App",
      downloadApk: "Download APK",
      downloadZip: "Backup ZIP",
      backupDownload: "Backup Download",
      downloads: {
        arm64: {
          title: "64-bit modern build (arm64-v8a)",
          hint: "Recommended for most newer Android phones, tablets, and devices",
        },
        armeabi: {
          title: "32-bit compatibility build (armeabi-v7a)",
          hint: "For older 32-bit Android devices",
        },
      },
      archGuide: {
        title: "Version Notes",
        arm64: "arm64-v8a: for most recent Android phones, tablets, TV boxes, and smart TVs.",
        armeabi: "armeabi-v7a: for some older 32-bit Android devices.",
        apk: "APK: direct installer package. Download it and install it on the device.",
        zip: "Backup ZIP: if APK download is blocked, download the ZIP, unzip it on your phone or TV, then install the APK inside.",
      },
      desc: {
        title: "Usage Instructions",
        section1Title: "Core Features",
        section1Body:
          "1. Use the Purchase button in the top-right corner to top up your account.\n2. Tap Refresh to fetch the latest route list.\n3. Tap Share to share routes with devices on your local network.\n4. Tap the chat button to contact WeChat support.\n\nRouting modes map to different routing strategies:\n1. Smart Routing: splits domestic and overseas traffic; only overseas sites use the route.\n2. Global Mode: all traffic goes through the route, which may affect domestic app experience.",
        section2Title: "Choose a Route",
        section2Body:
          "Choose a route based on your network environment and usage needs. The green tags on the right indicate the recommended carrier and route type.\nAfter selecting a route, tap the Connect button shown above to access the internet through LadderZ.",
      },
      usage: {
        title: "Usage Instructions",
        step1: "Download and install the app (APK or via store)",
        step2: "Open the app and sign in",
        step3: "Select a server and connect",
        step4: "Start using the service",
      },
    },
    windows: {
      softwareName: "Windows Client Placeholder",
      supportedDevices: "Supported devices: Windows 7 x64, Windwos 10/11+",
      version: "Current version: v1.0.0",
      currentVersionLabel: "Current Version",
      downloadInstaller: "Download Installer",
      downloadPortable: "Download Portable Version",
      desc: {
        title: "Usage Instructions",
        section1Title: "Install ZionLadder App",
        section1Body:
          'Run the downloaded installer. If a security warning appears, click "More info", then click "Run anyway" to complete the installation.',
        section2Title: "Basic Operations",
        section2Body:
          "Top-right action area:\n1. Cart button: renew your ZionLadder account.\n2. Refresh button: fetch the latest route list.\n3. Share button: share routes to your local network.\n4. WeChat button: add WeChat support.",
        section2RoutingTitle: "Routing Modes",
        section2RoutingBody:
          "1. Smart Routing: splits domestic and overseas traffic; only overseas sites use the route.\n2. Global Mode: all traffic goes through the route, which may affect domestic app experience.",
        section3Title: "Choose a Route",
        section3Body:
          "Choose a route based on your network environment and usage needs. The green tags on the right indicate the recommended carrier and route type.\nAfter selecting a route, tap the Connect button shown above to access the internet through LadderZ.",
      },
      usage: {
        title: "Usage Instructions",
        step1: "Download and install the client",
        step2: "Open the client and sign in",
        step3: "Select a server and connect",
        step4: "Start using the service",
      },
    },
    macos: {
      softwareName: "macOS Client Placeholder",
      supportedDevices: "Supported devices: Mac desktop / laptop - macOS 10.15+",
      heroSubtitle: "Choose the macOS client that fits your use case",
      version: "Current version: v1.0.0",
      advancedVersion: "App Store",
      currentVersionLabel: "Current Version",
      supportedSystem: "System",
      downloadApp: "Download App",
      installerGroup: "Standard",
      advancedGroup: "Advanced",
      installerSystem: "macOS 10.15+",
      advancedSystem: "macOS 12+",
      installerHint: "Proxy mode for web browsing",
      advancedHint: "VPN mode for all apps",
      choiceDivider: "or",
      downloadInstaller: "Download Installer",
      downloadAdvanced: "Advanced Version",
      getSharedAppleId: "Get Shared Apple ID",
      backupDownload: "Backup Download",
      usage: {
        title: "Usage Instructions",
        step1: "Download and install the client",
        step2: "Open the client and sign in",
        step3: "Select a server and connect",
        step4: "Start using the service",
      },
      versionGuide: {
        title: "Standard vs Advanced",
        standardTitle: "Standard: ",
        standardBody: "Uses proxy mode for browser traffic and apps that follow the system proxy.",
        advancedTitle: "Advanced: ",
        advancedBody:
          "Uses VPN mode for system-wide traffic, including AI desktop apps, CLI tools, developer tools, games, and other app scenarios.",
        appleIdHint:
          "The advanced version is downloaded from the App Store and usually requires an overseas Apple ID. If you do not have one, use the Shared Apple ID button on the left.",
        recommendHint:
          "For web browsing, start with the standard version. If you want all apps on your Mac to use the connection, choose the advanced version.",
      },
      desc: {
        title: "macOS Client Versions",
        standardTitle: "Installer",
        standardBody:
          "Recommended for most Mac users. Download the DMG installer, move ZionLadder to Applications, then open the app and sign in.",
        advancedTitle: "Advanced Version",
        advancedBody:
          "The advanced version is installed from the App Store and requires an overseas Apple ID. You can use the shared Apple ID provided here to download it, then switch back to your own Apple ID after installation.",
        sharedIdButton: "View Shared Apple ID",
      },
    },
    androidTv: {
      softwareName: "ZionLadder for Android TV",
      supportedDevices: "Supported devices: Android TV, TV boxes, and supported smart projectors",
      version: "Current version: v1.0.0",
      currentVersionLabel: "Current Version",
      downloadApp: "Download Android TV App",
      downloadApk: "Download APK",
      downloadZip: "Backup ZIP",
      backupDownload: "Backup Download",
      downloads: {
        arm64: {
          title: "64-bit modern build (arm64-v8a)",
          hint: "Recommended for most newer TVs, TV boxes, and smart projectors",
        },
        armeabi: {
          title: "32-bit compatibility build (armeabi-v7a)",
          hint: "For older 32-bit Android TV devices",
        },
      },
      archGuide: {
        title: "Version Notes",
        arm64: "arm64-v8a: for most recent Android TVs, TV boxes, and smart projectors.",
        armeabi: "armeabi-v7a: for some older 32-bit Android TV devices.",
        apk: "APK: direct installer package. Install it via USB drive, file manager, or TV browser.",
        zip: "Backup ZIP: if APK download is blocked, download the ZIP, unzip it on the TV or a computer, then install the APK inside.",
      },
      hero: {
        title: "ZionLadder for Android TV",
        subtitle: "For Android TV, TV boxes, and supported smart projectors",
      },
      usage: {
        title: "Usage Instructions",
        step1: "Download the APK package for TV devices",
        step2: "Install it via USB drive, browser, or file manager",
        step3: "Open the app and sign in to your ZionLadder account",
        step4: "Select a route and connect to start using the service",
      },
      desc: {
        title: "Android TV Setup",
        section1Title: "Installation",
        section1Body:
          "Android TV devices usually require manual APK installation. Download the file first, then install it via USB drive, LAN transfer, or the TV browser.",
        section2Title: "Recommendations",
        section2Body:
          "For TV streaming, choose routes with low latency and stable bandwidth. For older devices, try the backup package or armeabi-v7a build.",
      },
    },
    appleTv: {
      setupButton: "View Install Steps",
      sharedIdButton: "Get Shared Apple ID",
      hero: {
        title: "ZionLadder for Apple TV",
        subtitle:
          "Install ZionLadder from the App Store on Apple TV. The official app does not require manual subscription import.",
      },
      usage: {
        title: "Usage Instructions",
        step1: "Open the App Store on Apple TV",
        step2: "Use an overseas Apple ID to search for ZionLadder or ZionLadderTV and install it",
        step3: "Open the app and sign in to your ZionLadder account",
        step4: "Choose a route and turn on the connection",
      },
      desc: {
        title: "Apple TV Installation",
        section1Title: "Install Method",
        section1Body:
          "Apple TV is not suitable for installing apps through web download links. Search for ZionLadder or ZionLadderTV directly in the App Store on Apple TV.",
        section2Title: "Apple ID",
        section2Body:
          "If the app is not available in your current App Store region, temporarily sign in to the App Store with the shared Apple ID to download it. After installation, sign out of the shared account and switch back to your own Apple ID.",
      },
    },
    linux: {
      hero: {
        title: "ZionLadder for Linux",
        subtitle: "For Linux desktops, servers, development machines, and ARM devices",
      },
      usage: {
        title: "Usage Instructions",
        step1: "Download the x86_64/amd64 or arm64 package for your CPU architecture",
        step2: "Extract the archive and follow the README or install script",
        step3: "Sign in or import your subscription configuration",
        step4: "Start the service and configure system proxy or transparent proxy as needed",
      },
      desc: {
        title: "Linux Downloads",
        intro:
          "Choose the package matching your CPU architecture. If unsure, run uname -m in Terminal.",
      },
      downloads: {
        amd64:
          "For most 64-bit Intel/AMD Linux PCs, servers, and software routers, also known as x86_64/amd64.",
        arm64: "For 64-bit ARM Linux, including Raspberry Pi 4/5 and common ARM devices.",
      },
    },
    openwrt: {
      hero: {
        title: "ZionLadder for OpenWrt",
        subtitle: "For OpenWrt routers and software router devices",
      },
      usage: {
        title: "Usage Instructions",
        step1: "Confirm your OpenWrt version and CPU architecture",
        step2: "Use APK packages for OpenWrt 25.12+, and IPK packages for 24.10 or older",
        step3: "Upload and install the package from LuCI or SSH",
        step4: "Open the ZionLadder Web UI, sign in, and start the service",
      },
      desc: {
        title: "OpenWrt Downloads",
        intro:
          "Common devices usually use aarch64 builds; software routers often use x86_64. If unsure, check system information in LuCI or SSH.",
      },
      sections: {
        apk: {
          title: "OpenWrt 25.12 and above",
          subtitle: "APK package",
        },
        ipk: {
          title: "OpenWrt 24.10 and below",
          subtitle: "IPK package",
        },
      },
      groups: {
        common: "Common architectures",
        other: "Other architectures",
      },
    },
    merlin: {
      hero: {
        title: "ZionLadder for ASUS Merlin",
        subtitle: "For routers running Merlin or modified Merlin firmware",
      },
      usage: {
        title: "Installation",
        step1: "Download the offline package matching your router platform, CPU, or model",
        step2: "Extract it on the router: tar -xzf zionladder-PLATFORM.tar.gz",
        step3: "Enter the directory and run ./install.sh",
        step4: "Start the Web UI and open http://ROUTER-IP:10888/",
      },
      desc: {
        title: "Merlin Downloads",
        intro:
          "Packages include ZionLadder, runtime core, rule sets, Web UI, startup scripts, and Merlin hooks. Choose the matching original Merlin or KoolShare build.",
      },
      supportedModels: "Supported models",
      originalFirmware: "Original Merlin Firmware",
      koolshareFirmware: "KoolShare Software Center Build",
    },
    third: {
      title: "Third-Party App Setup",
      hero: {
        title: "Third-Party Apps",
        apps: "For experienced third-party client users only. We do not support third-party apps.",
        subscribeButton: "Subscription Links",
        usage: {
          title: "Important Notes",
          stabilityWarning:
            "When using subscription links, route stability and availability are not guaranteed. If routes suddenly stop working, you may need to update the subscription link manually.",
          shareWarning:
            "Do not share your subscription link. If you give it to anyone else, your account may be suspended at any time and will not be restored.",
          converterWarning:
            "Do not use third-party online subscription converters. Online conversion can leak route information, and accounts with leaked route information will be suspended.",
        },
      },
      quick: {
        title: "Quick Setup",
        subtitle: "Copy your personal subscription URL and import it into a suitable client.",
        loading: "Fetching subscription URL...",
        inputPlaceholder: "No subscription URL available",
        revealButton: "Reveal",
        hideButton: "Hide",
        copyButton: "Copy",
        copied: "Copied",
        hint: "The URL is masked by default. Click Reveal to view the full link.",
        fetchError: "Failed to fetch subscription URL. Please try again later.",
        copyError: "Copy failed. Please copy manually.",
      },
      recommendHint:
        "This page only provides subscription links for users who already know how to configure third-party clients. We do not provide third-party app downloads or setup guides here.",
      sourceTabs: {
        label: "Subscription Source",
        hint: "If the primary subscription fails, please try backup.",
        main: "Primary",
        backup: "Backup",
        backupMissing:
          "No backup subscription links are configured. Please switch back to primary.",
      },
      buttons: {
        download: "Download",
        appStore: "App Store",
        copySub: "Copy Subscription",
        oneClickImport: "One-Click Import",
        copied: "Copied",
      },
      linkTypes: {
        subscription: "General subscription link",
        clash: "Clash subscription link",
        singbox: "Sing-box subscription link",
      },
      platforms: {
        windows: "Windows",
        macos: "macOS",
        android: "Android",
        ios: "iOS",
        linux: "Linux",
        router: "Router",
      },
      platformNotes: {
        macos:
          "Install tip: if app installation fails, run sudo spctl --master-disable in Terminal",
        ios: "iOS clients require App Store purchase/download. Please use a non-mainland-China Apple ID",
      },
      apps: {
        clashVerge: "Powerful GUI client (recommended)",
        clashVergeMacTips:
          "If subscription fails, update to latest; if still failing, disable existing proxy first",
        clashParty: "If subscription fails, update to the latest client",
        v2rayn: "Lightweight V2Ray desktop client",
        v2raynMac: "If app is reported damaged, run: xattr -cr /Applications/v2rayN.app",
        v2rayu: "If blocked by macOS security, run: sudo spctl --master-disable",
        nekoray: "Desktop client with multi-protocol support",
        singbox: "General proxy platform with latest protocol support",
        clashNyanpasu: "Enhanced Clash client",
        flclash: "Modern client built with Flutter",
        clashmi: "New client based on Mihomo core",
        clashmiFreeIos: "Free iOS Clash client using Clash subscription",
        hiddify: "Easy-to-use multi-protocol client",
        sfm: "Official sing-box client for macOS",
        sfa: "Official sing-box client for Android",
        sfi: "Official sing-box client for iOS",
        cmfa: "Clash client for Android",
        cmfaTips: "If update shows EOF error, disconnect this profile first and update again",
        v2rayng: "V2Ray client for Android",
        nekobox: "Android client with multi-protocol support",
        shadowrocket: "Professional iOS client (paid on App Store)",
        shadowrocketTips: "If subscription fails or latency tests are all red, update Shadowrocket",
        stash: "Feature-rich iOS client",
        loon: "iOS client with rule-based routing support",
        loonTips: "Enable parser switch in Loon settings before importing subscription",
        quantumultx: "Update to latest QX and enable resource parser (version >= 1.5.5)",
        v2raya: "V2Ray client with web UI",
        qv2ray: "Qt cross-platform client",
        openclash: "Clash plugin for OpenWrt routers",
        openclashTips: "If GEOsite errors occur, switch GEO database to FULL version",
        passwall: "Multi-protocol proxy plugin for OpenWrt routers",
        passwallTips: "If errors occur, use Passwall2 below",
        passwall2: "If errors occur, update to latest version",
        ssrplus: "Must update plugin to latest; old versions do not support VLESS",
        merlin: "Popular proxy solution for Merlin firmware",
        merlin2: "Set GeoIP/GeoSite to FULL version before use",
      },
    },
  },
  manageAccount: {
    invalidLink: "Invalid account link.",
    topupFor: "You are topping up for the following user:",
    username: "Username",
    currentExpire: "Current Expiration",
    loading: "Loading...",
    notActivated: "Not activated yet",
  },
  auth: {
    signInTitle: "Sign in",
    signUpTitle: "Sign up",
    emailLabel: "Email",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm password",
    rememberMe: "Remember me",
    signInButton: "Sign in",
    signInButtonLoading: "Signing in…",
    signUpButton: "Sign up",
    signUpButtonLoading: "Signing up…",
    missingCredentials: "Please enter your email and password",
    missingSignupFields: "Please enter email, password, and confirm password",
    passwordMismatch: "The two passwords do not match",
    noAccount: "Don't have an account?",
    signUpLink: "Sign up",
    alreadyHaveAccount: "Already have an account?",
    goToSignInLink: "Go to sign in",
    emailExists: "This email is already registered",
    signupUnknownError: "Sign up failed, please try again later",
  },
};

export default en;
